export default __webpack_public_path__ + "static/media/mons16.80a8d7d6.jpg";